<template>
  <ul class="contact flex flex_center flex_between">
    <li class="contact_item"><span class="iconfont">&#xe776;</span>010-8076 5311</li>
    <li  class="contact_item"><b></b></li>
    <li class="contact_item"><span class="iconfont icon-xinfeng">&#xe623;</span>wujianvc@163.com</li>
    <li  class="contact_item"><b></b></li>
    <li class="contact_item"><span class="iconfont">&#xe62b;</span>微信搜索：18612886556</li>
  </ul>
</template>

<script>
export default {
  name: "Contact"
};
</script>

<style scoped lang="less">
  .contact{
    height: 72px;
    margin: 0;
    font-size: 24px;
    color: #FFFFFF;
    .contact_item{
      vertical-align: middle;
      &:last-child{
        border: none;
      }
      .iconfont{
        display: inline-block;
        width: 38px;
        height: 38px;
        background: #fff;
        border-radius: 50%;
        text-align: center;
        line-height: 38px;
        color: #2678CB;
        font-size: 22px;
        margin-right: 15px;
        &.icon-xinfeng{
          font-size: 16px;
        }
      }
      b{
        display: block;
        width: 2px;
        height: 42px;
        background: #FFFFFF;
      }
    }
  }
</style>
